<template>
    <div>

    
    <div class="search_header">
      <div>
        <div class="search_fn">
            <i class='icon1'></i>
            <div class="search-item">
              <form action="javascript:;">
                <input type="search" ref='search' @focus="insinte" @blur="insintes" @keyup.13="searchFns" autocomplete="off" placeholder="请输入关键字" v-model="keyWord" autocapitalize="off">
                <!--<i class="icon2" v-show="showClear" @click="delWord"></i>-->
              </form>
            </div>
         </div>
        <span class='usual' @click="clearInput">取消</span>

          <!-- todo new 202602 返回首页 -->
        <span class="to-home-icon" @click='toHome'>
          <img src="@/assets/imgs/home.png" alt="返回首页">
        </span>
      </div>
    </div>
    <div class='serchBox' v-if='serchlist.length>0' v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="50">
             <div class="cellList" v-for="(item,index) of serchlist" :key="index" >
                <div class="left" @click.stop="jumpDetails(item.file_type,item.id,item.category_id)">
                    <div class="leftDiv">
                        <img v-if="item.file_type==0" :src="item.thumbnail" alt="">
                        <img v-else-if="item.file_type==1"  src="@/assets/imgs/pdf.png" alt="">
                        <img v-else-if="item.file_type==2" class="lianjieImg"   src="@/assets/imgs/lianjie.png" alt="">
                        <img v-else :src="item.thumbnail" alt="">
                    </div>
                    <div v-if="item.file_type==0" >
                        <div v-show="item.photos_cnt!=1" class="photos_cnt">{{item.photos_cnt}} 张</div>
                    </div>
                    <div v-if="item.file_type==3" class="bofang"  @click.stop="getInfos(item.file_type,item.id,item.category_id)">
                        <img class="bofangImg" src="@/assets/imgs/bofang.png" alt="">
                    </div>
                </div>
                <div class="right">
                    <div class="rightTitle" @click.stop="jumpDetails(item.file_type,item.id,item.category_id)">  
                        <div class="title">
                                <p v-if="item.file_type==0 || item.file_type==1"  class="supTitle" v-html="ruleTitle(item.post_title)">
                                </p>
                                <p v-else-if="item.file_type==2" class="supTitle" v-html="ruleTitle(item.post_title)">
                                </p>
                                <p  v-else class="supTitle" v-html="ruleTitle(item.post_title)">
                                </p>
                        </div>
                    </div>
                    <!-- 下  时间/分享 -->
                    <div class="btColor">
                        <div @click.stop="jumpDetails(item.file_type,item.id,item.category_id)">
                            <span>{{item.published_time | timeType}}</span>
                        </div>
                        <!-- 点击弹出弹出层，指示分享 -->
                        <div class="eye">
                            <div>
                                <img class="icon" src="@/assets/imgs/eye.png" alt="">
                                <span>{{item.post_hits}}</span>
                            </div >
                            <div class='colect' @click.stop="toCollect(index,item.is_fav,item.id)">
                                <img class="icon" :src="item.is_fav=='1'?icon1:icon2" alt="">
                            </div>
                            <div v-if="item.file_type!=2" @click.stop="toShare(item)">
                                <img class="icon" src="@/assets/imgs/fx.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
              </div>
    </div>
    <div class='noData' v-show='zhixingSearch&&serchlist.length==0'>
            <img class='img1' src="@/assets/imgs/null1.png" alt=""><span>暂无搜索内容~</span>
        </div>
    <div  v-if="upShow" class="popup"  @click.stop="popup()">
            <img class="upImg" src="@/assets/imgs/popup.png" alt="">
            <div class="text">
                <p>立即分享给好友吧</p>
                <p>点击屏幕右上角将本页面分享给好友</p>
            </div>
        </div>
    
  </div>
</template>

<script>
import https from '@/https.js' 
import { mapState,mapActions } from 'vuex'
export default {
  name:'serch',
  data() {
    return {
      icon1:require('@/assets/imgs/star1.png'),
      icon2:require('@/assets/imgs/star.png'),
      serchlist:[],
      keyWord:'',
      upShow:false,
      busy:true,
      showClear:false,
      zhixingSearch:false,
      page:1
    };
  },
  created(){
      //todo new 20260305 添加搜索关键字参数 详情页返回时用 start
      // 从路由参数/本地存储读取搜索关键词（若有）
      if(this.$route.query.keyWord){
          this.keyWord = this.$route.query.keyWord || "";
          this.refreshList();
      }
      //todo new 20260305 添加搜索关键字参数 详情页返回时用 end

    this.intShare()
  },
  computed: {
    ...mapState([
        'pdfDefault',
        'linkDefault',
        'shareDefault'
    ])
  },
  methods:{
    ...mapActions([
      'searchFn',
      'addCollects',
      'deletCollects',
      'setVideoMsg',
      'getArticals'
    ]),
   async toCollect(cur,fav,curId){
          if(fav=='0'){
              this.shoucangFn(cur,curId)
          }else{
              this.deletShoucang(cur,curId)
          }
      },
      async shoucangFn(cur,curId){
          let info=new Object()
          info.id=curId
          let result=await this.addCollects(info)
          if(result.code=='1'){
              this.$toast(result.msg)
              this.serchlist[cur].is_fav=1
          }
      },
      async deletShoucang(cur,curId){
          let ids=new Array()
          ids.push(curId)
          let info=new Object()
          info.id=ids
          info.ia_all=0
          const result=await this.deletCollects(info)
          if(result.code=='1'){
              this.$toast(result.msg)
              this.serchlist[cur].is_fav=0

          }else{
              this.$toast('操作失败，请联系管理员')
          }
      },
      refreshList(){
        this.page=1;
        if(this.serchlist.length>0){
          this.zhixingSearch=false
        }
        this.serchlist=[];
        this.serchs();
        
      },
    ruleTitle(items) {
      let title = items;
      let rep = new RegExp(this.keyWord, "g");
      let resDtring = `<span style='color:#00878b;'>${this.keyWord}</span>`;
      return this.keyWord==''?title:title.replace(rep, resDtring);
    },
    popup(){
          this.upShow=!this.upShow
      },

      jumpDetails(type,id,cid){
          if(type==0 || type==1){      //图片，pdf
              //this.$router.push('/details?type='+type+'&id='+id)
              //todo new 20260305 添加搜索关键字参数
              //console.log('/details?type='+type+'&id='+id+'&keyWord='+this.keyWord);
              this.$router.push('/details?type='+type+'&id='+id+'&keyWord='+this.keyWord)
          }else{
             this.getInfos(type,id,cid)
          }
      },
      
      async getInfos(type,id,cid){
          let info=new Object()
          info.id=id
          let result=await this.getArticals(info)
          if(result.code=='1'){
              let res=result.data
              if(type=='2'){
                   var URL=res.source_path;
                var reg=/amp;/
                URL=URL.replace(reg,"");
                window.location.href=URL
              }else{
                this.setVideoMsg(res)
                //this.$router.push("/list?id="+cid+"&"+"videoId="+id)
                  //todo new 20260305 添加搜索关键字参数
                  //console.log("/list?id="+cid+"&"+"videoId="+id+'&keyWord='+this.keyWord);
                this.$router.push("/list?id="+cid+"&"+"videoId="+id+"&keyWord="+this.keyWord)
              }
             
          }
      },


    delWord(){
      this.showClear=false;
      this.keyWord='';
      this.zhixingSearch=false;
      this.serchlist=[];
    },
    searchFns(){
        this.$refs.search.blur();
        var keyWords=this.keyWord;
        if(keyWords==''){
          this.$toast('请输入关键字'); 
        }else{
            this.refreshList()
        }
    },
    insinte(){
      this.showClear=true
    },
    insintes(){
      if(this.keyWord==''){
          this.zhixingSearch=false;
          this.showClear=false;
          this.serchlist=[];
      }else{
          this.showClear=true;
      }
    },
    clearInput(){
				this.$router.back()
    },
    async loadMore() {
        this.busy = true;
        this.serchs();
    },
    async serchs(){
      let info=new Object()
      info.category_id=''
      info.page=this.page
      info.keyword=this.keyWord
       const result=await this.searchFn(info)
        if (result.code=='1') {
          let res=result.data
          this.serchlist=[...this.serchlist,...res.list]
          this.page=this.page+1
          this.zhixingSearch=true
          
        }
        this.busy=result.data.list&&result.data.list.length<10?true:false;
        
    },
    getURL(ptype,type,id,cid){
        let origin=window.location.origin
        if(type==0 || type==1){
          if(ptype=='URL'){
            return origin+'#/details?type='+type+'&id='+id
          }else{
              return type==0?this.shareDefault:this.pdfDefault 
          }
          
        }else if(type=='2'){
           if(ptype=='URL'){
             return this.getInfosURL(type,id,cid)
           }else{
             return this.linkDefault
           }
          
        }else if(type=='3'){
          if(ptype=='URL'){
            return origin+"#/list?id="+cid+"&"+"videoId="+id
          }else{
            return this.getInfosURL(type,id,cid)
          }
          
        }
      },
      async getInfosURL(type,id,cid){
          let info=new Object()
          info.id=id
          let result=await this.getArticals(info)
          if(result.code=='1'){
              let res=result.data
              if(type=='2'){
                  var reg=/amp;/
                  return res.source_path.replace(reg,"")
              }else{
                return res.thumbnail?res.thumbnail:this.shareDefault
              }
             
          }
      },
    intShare(){
      let origin=window.location.origin
      let sinfo=new Object()
      sinfo.shareTitle='实习进修胜任力平台-搜索'
      sinfo.shareDesc=''
      sinfo.shareUrl=origin+'#/search'
      sinfo.shareImg=this.shareDefault
      sessionStorage.setItem('sinfo',JSON.stringify(sinfo))
      this.wxShare(sinfo)
    },
    async toShare(item){
      this.upShow=true
      let origin=window.location.origin
      let parm=new Object()
      parm.shareTitle=item?item.post_title:'实习进修胜任力平台-搜索'
      parm.shareDesc=''
      parm.shareUrl=item?await this.getURL('URL',item.file_type,item.id,item.category_id):origin+'#/search'
      parm.shareImg=item.thumbnail?item.thumbnail:await this.getURL('IMG',item.file_type,item.id,item.category_id)
      this.wxShare(parm)
    },
    wxShare(parm){
          let parm2=new Object()
          parm2.shareTitle=parm.shareTitle,
          parm2.shareDesc=parm.shareDesc,
          parm2.shareUrl=parm.shareUrl,
          parm2.shareImg=parm.shareImg,
          this.$wxShare(parm2)
    },

      //todo new 202602添加返回首页功能
      toHome(){
          //this.$router.push({name:'home'})
          // 改造2：添加调试日志，排查路由实例和跳转是否执行
          console.log('toHome方法执行了', this.$router); // 若打印undefined，说明$router未注入
          // 方案A：保留name跳转（推荐，需保证路由表有name:home）
          /*this.$router.push({ name: 'home' }).catch(err => {
              // 捕获路由跳转错误（如重复跳转、路由不存在）
              console.log('路由跳转失败：', err);
              // 方案B：降级为path跳转（无需name，直接按路径匹配）
              this.$router.push('/');
          });*/

          // todo new 20260305 搜索完成返回上一页 start
          //this.$router.push('/');
          //this.$router.push({name:'home'});
          // 有历史记录，返回上一页
          try {
              //this.$router.go(-1);
              //this.$router.back()
              this.$router.push({name:'home'});
          } catch (err) {
              // 兜底：极少数情况下 go(-1) 报错（如路由历史异常），降级跳首页
              console.log('路由返回失败：', err);
              this.$router.push('/');
          }
          // todo new 20260305 搜索完成返回上一页 end
      },
  }
};
</script>
<style src="@/assets/search.css" scoped></style>
<style scoped>
    /* 原有样式保留，新增以下样式 */
    .search_header > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px; /* 增加内边距，避免元素挤在一起 */
    }
    .usual {
        margin-right: 10px; /* 与首页图标保持间距 */
        cursor: pointer;
    }
    /* 改造3：给首页图标设置宽高+点击样式，保证有效点击区域 */
    .to-home-icon {
        display: inline-block; /* 行内块，支持宽高 */
        width: 30px; /* 自定义，根据设计稿调整 */
        height: 30px; /* 与宽度一致，保证图标比例 */
        cursor: pointer; /* 鼠标悬浮变手型，提示可点击 */
    }
    .to-home-icon img {
        width: 100%;
        height: 100%;
        object-fit: contain; /* 保持图片比例，不拉伸 */
    }

    /* 你的原有样式 */
    .search_header {
        width: 100%;
        background: #fff;
        border-bottom: 1px solid #f1f1f1;
        padding: 8px 0;
    }
    .search_fn {
        display: flex;
        align-items: center;
        flex: 1;
    }
    .icon1 {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        background: url(~@/assets/imgs/star1.png) no-repeat center;
        background-size: 100%;
    }
    .search-item {
        flex: 1;
        position: relative;
    }
    .search-item input {
        width: 100%;
        height: 30px;
        border: 1px solid #eee;
        border-radius: 15px;
        padding: 0 30px 0 15px;
        font-size: 14px;
        outline: none;
    }
    .icon2 {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        background: url(~@/assets/imgs/star.png) no-repeat center;
        background-size: 100%;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/search.vue